// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import RecordingStatus from "enums/RecordingStatus";
import SocialRecordingParticipant, { processSocialRecordingParticipantArray } from "./SocialRecordingParticipant";
import User, { processUser } from "./User";
import Util from "PreciateUtil";

export default interface SocialRecording {
    socialRecordingId?: string;
    socialId?: string;
    userId?: string;
    recordingId?: string;
    status?: RecordingStatus;
    name?: string;
    s3Bucket?: string;
    recordingSize?: number;
    startDateTime?: Date;
    endDateTime?: Date;
    processingStartDateTime?: Date;
    processingEndDateTime?: Date;
    participants?: SocialRecordingParticipant[];
    user?: User;
}

export function processSocialRecording(value?: SocialRecording): void {
  if (value) {
    value.startDateTime = Util.toDate((value as any).startDateTime);
    value.endDateTime = Util.toDate((value as any).endDateTime);
    value.processingStartDateTime = Util.toDate((value as any).processingStartDateTime);
    value.processingEndDateTime = Util.toDate((value as any).processingEndDateTime);
    processSocialRecordingParticipantArray(value.participants);
    processUser(value.user);
  }
}

export function processSocialRecordingArray(array?: SocialRecording[]): void {
  if (array) {
    for (const v of array) {
      processSocialRecording(v);
    }
  }
}
